<template>
  <PAGE :is-sys="false" />
</template>
<script>
import PAGE from './components/Page';
export default {
  name: 'BusinessLabelHand',
  components: { PAGE },
  data() {
    return {};
  },
};
</script>
